import { Navigate, useParams, useSearchParams } from "react-router-dom";

/** Preserves `division` query; sets tab=community on canonical /divisions URL. */
export function LegacyDivisionAnalysisRedirect() {
  const [searchParams] = useSearchParams();
  const division = searchParams.get("division");
  const next = new URLSearchParams();
  if (division) next.set("division", division);
  next.set("tab", "community");
  return <Navigate to={`/divisions?${next.toString()}`} replace />;
}

/** Preserves `division` query; sets tab=briefing on canonical /divisions URL. */
export function LegacyDivisionBriefingRedirect() {
  const [searchParams] = useSearchParams();
  const division = searchParams.get("division");
  const next = new URLSearchParams();
  if (division) next.set("division", division);
  next.set("tab", "briefing");
  return <Navigate to={`/divisions?${next.toString()}`} replace />;
}

export function LegacyDivisionEditorIndexRedirect() {
  return <Navigate to="/divisions/editor" replace />;
}

export function LegacyDivisionEditorDescriptorRedirect() {
  const { descriptor } = useParams<{ descriptor: string }>();
  return (
    <Navigate
      to={`/divisions/editor/${encodeURIComponent(descriptor ?? "")}`}
      replace
    />
  );
}
